import { useContext } from 'react'

import { ValidationContext } from '../context/validationContext'

export const useValidationContext = () => {
	const context = useContext(ValidationContext)

	if (!context) throw new Error('useValidationContext needs to be wrapt in ValidationContext')

	return context
}
